import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lesson-form"
// Manages dynamic addition/removal of lesson_skills in lesson form
export default class extends Controller {
  static targets = ["skillsContainer", "skillTemplate", "emptyMessage"]
  static values = { programOptionsUrl: String }

  connect() {
    this.skillIndex = this.skillsContainerTarget.children.length
    console.log("Lesson form controller connected")
  }

  // When the student changes on the new/edit lesson form, the program
  // select is only built server-side for the student present at initial
  // render — picking a different student left it empty with no way to
  // choose a program. Reload the program <select>'s turbo frame scoped to
  // the newly chosen student (Turbo Drive is off app-wide, so nothing else
  // would refresh it).
  studentChanged(event) {
    if (!this.hasProgramOptionsUrlValue) return

    const frame = document.getElementById("lesson_program_field")
    if (!frame) return

    const studentId = event.target.value
    const url = new URL(this.programOptionsUrlValue, window.location.origin)
    if (studentId) url.searchParams.set("student_id", studentId)

    frame.src = `${url.pathname}${url.search}`
  }

  addSkill(event) {
    event.preventDefault()

    // Hide empty message if present
    if (this.hasEmptyMessageTarget) {
      this.emptyMessageTarget.style.display = 'none'
    }

    // Check if template exists
    if (!this.hasSkillTemplateTarget) {
      console.error("Skill template not found!")
      return
    }

    // Get template content
    const template = this.skillTemplateTarget.content.cloneNode(true)
    const newSkillHtml = template.querySelector('.lesson-skill-fields')

    if (newSkillHtml) {
      // Replace NEW_RECORD with unique timestamp index
      const uniqueId = new Date().getTime()
      const originalHTML = newSkillHtml.innerHTML
      newSkillHtml.innerHTML = originalHTML.replace(/NEW_RECORD/g, uniqueId)

      // Add to container
      this.skillsContainerTarget.appendChild(newSkillHtml)

      // Scroll to new skill
      newSkillHtml.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    } else {
      console.error("Could not find .lesson-skill-fields in template")
    }
  }

  removeSkill(event) {
    event.preventDefault()

    const skillField = event.target.closest('.lesson-skill-fields')

    if (skillField) {
      // Check if this is a persisted record
      const destroyField = skillField.querySelector('input[name*="_destroy"]')

      if (destroyField) {
        // Mark for destruction but keep in DOM (Rails will handle on submit)
        destroyField.value = '1'
        skillField.style.display = 'none'
      } else {
        // New record, just remove from DOM
        skillField.remove()
      }

      // Show empty message if no skills left
      const visibleSkills = Array.from(this.skillsContainerTarget.children).filter(
        child => child.style.display !== 'none'
      )

      if (visibleSkills.length === 0 && this.hasEmptyMessageTarget) {
        this.emptyMessageTarget.style.display = 'block'
      }
    }
  }
}
